export default "__VITE_ASSET__BajTvPAG__"